import React from 'react';

import { Button, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ReactHookFormInputDatePicker from 'common/components/form/ReactHookFormInputDatePicker';

const DateFilterForm = ({ initialValues, onSubmit }) => {
    const { t } = useTranslation();
    const { control, handleSubmit } = useForm({
        defaultValues: initialValues,
        mode: 'onChange',
    });

    return (
        <Grid component="form" onSubmit={handleSubmit(onSubmit)}>
            <Grid container>
                <Grid size="grow">
                    <ReactHookFormInputDatePicker
                        control={control}
                        fullWidth
                        label={t('Start date')}
                        maxDate={new Date()}
                        name="initial_date"
                    />
                </Grid>

                <Grid size="grow">
                    <ReactHookFormInputDatePicker
                        control={control}
                        fullWidth
                        label={t('Final date')}
                        maxDate={new Date()}
                        name="final_date"
                    />
                </Grid>

                <Grid>
                    <Button type="submit">{t('Filter')}</Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

DateFilterForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default DateFilterForm;
